<ion-text>
  <h2>{{text}}</h2>
</ion-text>
